import React, { Component, useContext } from "react";
import { Link } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { Trans } from "react-i18next";
import { withRouter } from "../withRouter"; // ton HOC
import { UserContext } from "../../UserContext";

class Sidebar extends Component {
  state = {};
  static contextType = UserContext;

  componentDidMount() {
    const { user } = this.context;
    if (!user) {
      this.props.router.navigate("/user-pages/register-1");
    }
  }
  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector("#sidebar").classList.remove("active");
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: "/apps", state: "appsMenuOpen" },
      { path: "/basic-ui", state: "basicUiMenuOpen" },
      { path: "/advanced-ui", state: "advancedUiMenuOpen" },
      { path: "/form-elements", state: "formElementsMenuOpen" },
      { path: "/tables", state: "tablesMenuOpen" },
      { path: "/maps", state: "mapsMenuOpen" },
      { path: "/icons", state: "iconsMenuOpen" },
      { path: "/braiderpay", state: "valpayMenuOpen" },
      { path: "/user-pages", state: "userPagesMenuOpen" },
      { path: "/error-pages", state: "errorPagesMenuOpen" },
      { path: "/consultations", state: "consultsMenuOpen" },
      { path: "/ecommerce", state: "ecommercePagesMenuOpen" },
      { path: "/clients", state: "clientsMenuOpen" },
      { path: "/suivi-rencontre", state: "suivirencontreMenuOpen" },
      { path: "/produits", state: "produitsMenuOpen" },
      { path: "/tresseuses", state: "tresseusesMenuOpen" },
      { path: "/utilisateurs", state: "utlseMenuOpen" },
      { path: "/rencontres", state: "rencontreeMenuOpen" },
      { path: "/lservices", state: "lserviceseMenuOpen" },
      { path: "/caisses", state: "caissesMenuOpen" },
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true });
      }
    });
  }

  render() {
    const { user } = this.context;
    let ldrt = user?.permission_ids;
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          <li className="nav-item nav-profile">
            <a
              href="!#"
              className="nav-link"
              onClick={(evt) => evt.preventDefault()}
            >
              <div className="nav-profile-text">
                <span className="font-weight-bold mb-2">
                  <Trans>
                    {" "}
                    <span>{}</span>
                  </Trans>
                </span>
              </div>
            </a>
          </li>

          <li
            className={
              this.isPathActive("/competitions")
                ? "nav-item active"
                : "nav-item"
            }
          >
            <div
              className={
                this.state.clientsMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("clientsMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Clients</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-trophy-variant-outline mdi"></i>
            </div>
            <Collapse in={this.state.clientsMenuOpen}>
              <ul className="nav flex-column sub-menu">
                {ldrt?.includes(4) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/viewcltslst")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/viewcltslst"
                    >
                      <Trans>New Client</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(405) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/competitions/Newengagement")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/competitions/Newengagement"
                    >
                      <Trans>Update Client</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(28) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/competitions/Newengagement")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/competitions/Newengagement"
                    >
                      <Trans>Delete Client</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(31) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/cltsblk")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/cltsblk"
                    >
                      <Trans>Put in Blacklist</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(6) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/nwcomcomp")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/nwcomcomp"
                    >
                      <Trans>Print List</Trans>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </Collapse>
          </li>

          <li
            className={
              this.isPathActive("/discplines") ? "nav-item active" : "nav-item"
            }
          >
            <div
              className={
                this.state.tresseusesMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("tresseusesMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Hair Stylists</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-airballoon"></i>
            </div>
            <Collapse in={this.state.tresseusesMenuOpen}>
              <ul className="nav flex-column sub-menu">
                {ldrt?.includes(7) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/viewbraids")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/viewbraids"
                    >
                      <Trans>New Stylist</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(408) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/discplines/Newsdiscipline")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/discplines/Newsdiscipline"
                    >
                      <Trans>Update Stylist</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(29) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/discplines/Newsdiscipline")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/discplines/Newsdiscipline"
                    >
                      <Trans>Delete Stylist</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(9) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/discplines/Newsdiscipline")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/discplines/Newsdiscipline"
                    >
                      <Trans>Print List</Trans>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </Collapse>
          </li>

          <li
            className={
              this.isPathActive("/form-elements")
                ? "nav-item active"
                : "nav-item"
            }
          >
            <div
              className={
                this.state.produitsMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("produitsMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Type of Hair Style</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-thumbs-up-down"></i>
            </div>
            <Collapse in={this.state.produitsMenuOpen}>
              <ul className="nav flex-column sub-menu">
                {ldrt?.includes(10) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/viewpdts")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/viewpdts"
                    >
                      <Trans>New type</Trans>
                    </Link>
                  </li>
                ) : null}
                {ldrt?.includes(4011) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/sanctions/Newsanction")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/sanctions/Newsanction"
                    >
                      <Trans>Update type</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(30) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/sanctions/Newsanction")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/sanctions/Newsanction"
                    >
                      <Trans>Delete type</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(12) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/sanctions/Newsanction")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/sanctions/Newsanction"
                    >
                      <Trans>Print List</Trans>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </Collapse>
          </li>

          <li
            className={
              this.isPathActive("/tables") ? "nav-item active" : "nav-item"
            }
          >
            <div
              className={
                this.state.caissesMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("caissesMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Cashier line</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-account-multiple-outline"></i>
            </div>
            <Collapse in={this.state.caissesMenuOpen}>
              <ul className="nav flex-column sub-menu">
                {ldrt?.includes(13) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/nwsale")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/nwsale"
                    >
                      <Trans>New Cashier line</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(40) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/lancerencontre")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/lancerencontre"
                    >
                      <Trans>Update Cashier line </Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(14) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/opencais")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/opencais"
                    >
                      <Trans>Open line </Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(15) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/closecais")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/closecais"
                    >
                      <Trans>Close line</Trans>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </Collapse>
          </li>

          <li
            className={
              this.isPathActive("/charts") ? "nav-item active" : "nav-item"
            }
          >
            <div
              className={
                this.state.valpayMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("valpayMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Braider payment</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-apps"></i>
            </div>
            <Collapse in={this.state.valpayMenuOpen}>
              <ul className="nav flex-column sub-menu">
                {ldrt?.includes(16) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/valdailypay")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/valdailypay"
                    >
                      <Trans>Validate daily salary</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(17) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/PrintPaySlip")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/PrintPaySlip"
                    >
                      <Trans>Print payment slip</Trans>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </Collapse>
          </li>

          <li
            className={
              this.isPathActive("/error-pages") ? "nav-item active" : "nav-item"
            }
          >
            <div
              className={
                this.state.suivirencontreMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("suivirencontreMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Returns management</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-apps"></i>
            </div>
            <Collapse in={this.state.suivirencontreMenuOpen}>
              <ul className="nav flex-column sub-menu">
                {ldrt?.includes(40) ? (
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/suivi-rencontre/Newengaths")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/suivi-rencontre/Newengaths"
                    >
                      Redo the hairstyle
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(40) ? (
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/error-pages/error-500")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/error-pages/error-500"
                    >
                      Reassign service
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(40) ? (
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/basic-ui/Buttons")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/basic-ui/Buttons"
                    >
                      Refund the customer
                    </Link>
                  </li>
                ) : null}
              </ul>
            </Collapse>
          </li>
          <li
            className={
              this.isPathActive("/general-pages")
                ? "nav-item active"
                : "nav-item"
            }
          >
            <div
              className={
                this.state.consultsMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("consultsMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Consultations</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-trophy-outline"></i>
            </div>
            <Collapse in={this.state.consultsMenuOpen}>
              <ul className="nav flex-column sub-menu">
                {ldrt?.includes(23) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/viewtreswrk")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/viewtreswrk"
                    >
                      <Trans>Consult Serv T.</Trans>
                    </Link>
                  </li>
                ) : null}
                {ldrt?.includes(24) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/viewcltslists")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/viewcltslists"
                    >
                      <Trans>Consult Clients.</Trans>
                    </Link>
                  </li>
                ) : null}
                {ldrt?.includes(25) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/viewbllst")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/viewbllst"
                    >
                      <Trans>Consult Blacklist</Trans>
                    </Link>
                  </li>
                ) : null}
                {ldrt?.includes(26) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/general-pages/blank-page")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/general-pages/blank-page"
                    >
                      <Trans>View payments</Trans>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </Collapse>
          </li>
          <li
            className={
              this.isPathActive("/utilisateurs")
                ? "nav-item active"
                : "nav-item"
            }
          >
            <div
              className={
                this.state.utlseMenuOpen ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => this.toggleMenuState("utlseMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Utilisateurs</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-lock menu-icon"></i>
            </div>
            <Collapse in={this.state.utlseMenuOpen}>
              <ul className="nav flex-column sub-menu">
                {ldrt?.includes(18) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/utilisateurs/NewGroupe")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/utilisateurs/NewGroupe"
                    >
                      <Trans>New Groupe</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(19) ? (
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/updategrp")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/updategrp"
                    >
                      <Trans>Update Groupe</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(20) ? (
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/nwuser")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/nwuser"
                    >
                      <Trans>New User</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(21) ? (
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/nwupdateusers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/nwupdateusers"
                    >
                      <Trans>Update User</Trans>
                    </Link>
                  </li>
                ) : null}

                {ldrt?.includes(22) ? (
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/updateusers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/updateusers"
                    >
                      <Trans>Update Password</Trans>
                    </Link>
                  </li>
                ) : null}
                {ldrt?.includes(27) ? (
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/infoadm")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/infoadm"
                    >
                      <Trans>Super admin</Trans>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </Collapse>
          </li>
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    const pathname = this.props?.router?.location?.pathname;
    if (!pathname) return false; // sécurité si router non défini
    return pathname === path;
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }
}

export default withRouter(Sidebar);
